/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Underline_Event_TextInputs */



/**
* | output |
* | --- |
* | "Underline event text" |
*
* @param {Underline_Event_TextInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const underline_event_text = /** @type {((inputs?: Underline_Event_TextInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Underline_Event_TextInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Texte d'événement souligné")
	if (locale === "de") return /** @type {LocalizedString} */ ("Ereignistext unterstreichen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Sottolinea il testo dell'evento")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Подчеркните текст события")
	if (locale === "es") return /** @type {LocalizedString} */ ("Subrayar el texto del evento")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("用下划线标出事件文本")
	if (locale === "ja") return /** @type {LocalizedString} */ ("イベントテキストに下線を引く")
	if (locale === "hi") return /** @type {LocalizedString} */ ("इवेंट टेक्स्ट को रेखांकित करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Sublinhe o texto do evento")
	return /** @type {LocalizedString} */ ("Underline event text")
});